import type { DateValueI } from '@/utils/filterDrawers'
import { OptionI } from '@/utils/forms/optionBuilders'

export type { DateValueI }

export const CUSTOM_INDEX = 4

export const getCustomDates = (option: OptionI<number | DateValueI>) => {
  const customOption = option?.value as DateValueI
  // Update time to avoid tz offsets setting the incorrect date.
  const savedStartDate = new Date(
    new Date(customOption?.gte).setUTCHours(new Date().getHours())
  )
  const savedEndDate = new Date(
    new Date(customOption?.lte).setUTCHours(new Date().getHours())
  )
  return {
    startDate: customOption?.gte ? savedStartDate : new Date(),
    endDate: customOption?.lte ? savedEndDate : new Date(),
  }
}

export const getDefaultIndex = (
  options: OptionI<number | DateValueI>[],
  option: OptionI<number | DateValueI>
): number => {
  if (isObject(option?.value)) {
    return CUSTOM_INDEX
  } else {
    return options?.findIndex((opt) => opt?.value === option?.value)
  }
}

const isObject = (value) => {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof RegExp) &&
    !(value instanceof Date) &&
    !(value instanceof Set) &&
    !(value instanceof Map)
  )
}

export const getStartOfDay = (date: Date) =>
  new Date(date.setUTCHours(0, 0, 0, 0)).toISOString()
export const getEndOfDay = (date: Date) =>
  new Date(date.setUTCHours(23, 59, 59, 999)).toISOString()
